import React from 'react'
import PropTypes from 'prop-types'
import ReactCursorPosition from 'react-cursor-position'
import styled from 'styled-components'
import Notification from './Notification'
import {TransitionGroup} from 'react-transition-group'

const notificationMaxWidth = 175
const notificationMargin = 40

class NotificationContainer extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            notifications: [],
        }
        this.cursor = {}
    }

    addAlert = (position, message, duration = 3000) => {
        let notifications = JSON.parse(JSON.stringify(this.state.notifications))
        const elementDimensions = JSON.parse(JSON.stringify(this.cursor.elementDimensions))
        const cursorY = JSON.parse(JSON.stringify(this.cursor.position.y))
        const cursorX = JSON.parse(JSON.stringify(this.cursor.position.x))

        let safePosition = position
        if (cursorX < (notificationMaxWidth + notificationMargin) / 2) {
            safePosition = 'right'
        } else if (elementDimensions.width - cursorX > 0 &&
            elementDimensions.width - cursorX < (notificationMaxWidth + notificationMargin) / 2) {
            safePosition = 'left'
        } else if (cursorY < notificationMaxWidth && position === 'top') {
            safePosition = 'bottom'
        } else if (elementDimensions.height - cursorY > 0 &&
            elementDimensions.height - cursorY > notificationMaxWidth &&
            position === 'bottom') {
            safePosition = 'top'
        }

        if (notifications.filter(notification => notification.message === message).length > 0) {
            return
        }

        notifications = []

        notifications.push({
            message: message,
            position: safePosition,
            top: cursorY,
            left: cursorX,
            isVisible: true,
            maxWidth: notificationMaxWidth,
        })

        this.setState({
            notifications: notifications,
        }, () => this.hideAlert(message, duration))
    }

    onCursorPositionChanged = (cursor) => {
        if (cursor.hasOwnProperty('elementDimensions')) {
            this.cursor = cursor
        }
    }

    hideAlert = (message, duration) => {
        setTimeout(() => {
            let notifications = JSON.parse(JSON.stringify(this.state.notifications))
            const result = notifications.filter(notification => notification.message !== message)
            this.setState({notifications: result})
        }, duration)
    }

    mapNotifications = (notification) => {
        return (
            <Notification
                key={JSON.stringify(notification)}
                position={notification.position}
                top={notification.top}
                left={notification.left}
                message={notification.message}
                maxWidth={notificationMaxWidth}/>
        )
    }

    render () {
        const {
            children,
        } = this.props

        const {
            notifications,
        } = this.state

        const items = notifications.map(this.mapNotifications)
        return (
            <ReactCursorPosition onPositionChanged={this.onCursorPositionChanged}>
                <NotificationWrapper>
                    <TransitionGroup>
                        {items}
                    </TransitionGroup>
                    {children}
                </NotificationWrapper>
            </ReactCursorPosition>
        )
    }
}

NotificationContainer.propTypes = {}

export default NotificationContainer

const NotificationWrapper = styled.div`
    position: relative;
`



// WEBPACK FOOTER //
// ./src/jsx/Components/Container/Molecules/NotificationContainer.jsx